type FormatType = 'number';

type Count = number | null | undefined;

type Pluralize = {
  suffix?: string;
  format?: FormatType;
  textOnly?: boolean;
}

const pluralize = (count: Count, item: string, options?: Pluralize) => {
  if (count === undefined || count === null) {
    return 'undefined count';
  }

  const suffix = options?.suffix || 's';
  // only a ternary because there's 2 options. can expand to a switch as necessary
  const number = options?.format === 'number' ? count : count.toLocaleString();

  if (options?.textOnly) {
    return `${item}${count !== 1 ? suffix : ''}`;
  }

  return `${number} ${item}${count !== 1 ? suffix : ''}`;
};

export default pluralize;
